define("shared/components/shared/social/facebook-page", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::Button
    @additional="block"
    @class="o--btn--selectable u--inline {{if @isSelected 'is--selected'}}"
    @onClick={{(fn @selectPage @page)}}
    @variant="outline"
    ...attributes
  >
    <div class="o--user">
      <img class="o--user__avatar is--square" src={{@page.picture.data.url}} />
      <span class="o--user__title u--p__t__sm">
        {{if @page.name_with_location_descriptor @page.name_with_location_descriptor @page.name}}
      </span>
    </div>
  </Shared::Ui::Button>
  */
  {
    "id": "Wy0TLnXK",
    "block": "[[[8,[39,0],[[17,1]],[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",[29,[\"o--btn--selectable u--inline \",[52,[30,2],\"is--selected\"]]],[28,[37,2],[[30,3],[30,4]],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n    \"],[10,\"img\"],[14,0,\"o--user__avatar is--square\"],[15,\"src\",[30,4,[\"picture\",\"data\",\"url\"]]],[12],[13],[1,\"\\n    \"],[10,1],[14,0,\"o--user__title u--p__t__sm\"],[12],[1,\"\\n      \"],[1,[52,[30,4,[\"name_with_location_descriptor\"]],[30,4,[\"name_with_location_descriptor\"]],[30,4,[\"name\"]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]]],[\"&attrs\",\"@isSelected\",\"@selectPage\",\"@page\"],false,[\"shared/ui/button\",\"if\",\"fn\"]]",
    "moduleName": "shared/components/shared/social/facebook-page.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});